import { Container, Sprite, Texture } from "pixi.js";
import { AssetKeys } from "./Assets";

const POOL_SIZE = 8;
const OVERLAP_FRACTION = 0.4;
const HEIGHT_FRACTION_LANDSCAPE = 0.22;
const HEIGHT_FRACTION_PORTRAIT = 0.16;
const PARALLAX_SPEED = 0.6;
const TOP_OFFSET_FRACTION = 0.15;

export class TopFoliage extends Container {
  private bushes: Sprite[] = [];
  private texture: Texture;
  private bushWidth = 0;
  private spacing = 0;
  private wrap = 0;
  private viewW = 0;
  private scrollX = 0;

  constructor(textures: Record<string, Texture>) {
    super();
    this.texture = textures[AssetKeys.BgMid];
    for (let i = 0; i < POOL_SIZE; i++) {
      const s = new Sprite(this.texture);
      s.anchor.set(0.5, 0);
      this.bushes.push(s);
      this.addChild(s);
    }
  }

  resize(width: number, height: number) {
    const portrait = height > width * 1.25;
    const targetH = height * (portrait ? HEIGHT_FRACTION_PORTRAIT : HEIGHT_FRACTION_LANDSCAPE);
    const scale = targetH / this.texture.height;
    this.viewW = width;
    this.bushWidth = this.texture.width * scale;
    this.spacing = this.bushWidth * (1 - OVERLAP_FRACTION);
    this.wrap = POOL_SIZE * this.spacing;
    const yOffset = -targetH * TOP_OFFSET_FRACTION;
    for (const b of this.bushes) {
      b.scale.set(scale);
      b.y = yOffset;
    }
    this.layout();
  }

  update(dt: number, scrollSpeed: number) {
    this.scrollX += scrollSpeed * dt * PARALLAX_SPEED;
    this.layout();
  }

  private layout() {
    if (this.wrap <= 0) return;
    const half = this.bushWidth * 0.5;
    for (let i = 0; i < this.bushes.length; i++) {
      let x = i * this.spacing - this.scrollX;
      x = ((x % this.wrap) + this.wrap) % this.wrap;
      if (x > this.viewW + half) x -= this.wrap;
      this.bushes[i].x = x;
    }
  }
}
